<template>
  <el-card class="card-main">
    <template v-if="(patrolUnitList && patrolUnitList.length)">
      <el-tabs type="card" v-model="searchForm.patrolUnit" @tab-click="onSearch">
        <el-tab-pane v-for="(item, index) in patrolUnitList" :label="item" :name="item === '项目自查' ? '2' : '1'"
          :key="index"></el-tab-pane>
      </el-tabs>
      <el-form inline ref="searchForm" :model="searchForm">
        <el-form-item prop="planName">
          <el-input v-model="searchForm.planName" placeholder="请输入任务名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="projectId">
          <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" filterable clearable>
            <el-option v-for="(item, index) in projectList" :label="item.projectName" :value="item.projectId"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <template>
          <el-form-item prop="safeManageId">
            <el-select v-model="searchForm.safeManageId" placeholder="请选择管理类型" filterable clearable>
              <el-option v-for="(item, index) in safeManageList" :label="item.safeManageName" :value="item.safeManageId"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item prop="patrolMode">
          <el-select v-model="searchForm.patrolMode" placeholder="请选择巡查方式" filterable clearable>
            <el-option v-for="(item, index) in patrolModeList" :label="item" :value="index + 1"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="planType">
          <el-select v-model="searchForm.planType" placeholder="请选择巡查类型" filterable clearable>
            <el-option v-for="(item, index) in planTypeList" :label="item" :value="index + 1" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="planStatus">
          <el-select v-model="searchForm.planStatus" placeholder="请选择任务状态" clearable>
            <el-option v-for="(item, index) in planStatusList" :label="item" :value="index" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <div class="mb20">
        <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-show="$ButtonShow('PLA_ADD_01')">新增任务</el-button>
        <el-button @click="setShow = true" type="primary" v-show="$ButtonShow('USC_SEL_02')">巡查设置</el-button>
        <custom-export type="1" :params="searchForm" v-show="$ButtonShow('PLA_DOWNLOAD_01')"></custom-export>
      </div>

      <el-table class="global-table" v-loading="loading" :data="planList">
        <el-table-column label="管理类型" show-overflow-tooltip prop="safeManageName" min-width="100"></el-table-column>
        <el-table-column label="任务名称" show-overflow-tooltip prop="planName" min-width="120"></el-table-column>
        <el-table-column label="所属项目" show-overflow-tooltip prop="projectName" min-width="100"></el-table-column>
        <el-table-column label="巡查方式" prop="patrolMode">
          <template v-slot="{ row }">
            {{ [1, 2].includes(row.patrolMode) ? patrolModeList[row.patrolMode - 1] : '' }}
          </template>
        </el-table-column>
        <el-table-column label="巡查频次" prop="patrolFrequency">
          <template v-slot="{ row }">
            {{ row.patrolFrequency }}次{{ [1, 2, 3].includes(row.planType) ? '/' + ['日', '周', '月'][row.planType - 1] : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="巡查类型" prop="planType">
          <template v-slot="{ row }">
            {{ [1, 2, 3].includes(row.planType) ? planTypeList[row.planType - 1] : '' }}
          </template>
        </el-table-column>
        <el-table-column label="任务指派人" prop="createUserName">
          <template v-slot="{ row }">
            {{ row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column label="完成情况" prop="taskCount">
          <template v-slot="{ row }">
            {{ row.ywcTaskCount + '/' + row.taskCount }}
          </template>
        </el-table-column>
        <el-table-column label="任务执行人" prop="executeUserName"></el-table-column>
        <el-table-column label="任务状态" prop="planStatus">
          <template v-slot="{ row }">
            {{ [0, 1].includes(row.planStatus) ? planStatusList[row.planStatus] : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onRecord(row.planId)" v-show="$ButtonShow('TAS_SEL_03')">执行记录</el-button>
            <el-button type="text" @click="onEdit(row.planId)" v-show="$ButtonShow('PLA_EDT_02')">编辑</el-button>
            <el-button type="text" @click="onOperate(row)" v-show="$ButtonShow('PLA_EDT_01')">{{ row.planStatus === 0 ?
              '禁用' : '启用' }}</el-button>
            <el-button type="text" @click="onDelete(row)" v-show="$ButtonShow('PLA_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
      <SafeSet :setShow.sync="setShow"></SafeSet>
      <ManageDetail :isShowRecord.sync="isShowRecord" :planId="planId" @loadData="loadData"></ManageDetail>
    </template>
    <NoData v-else></NoData>
  </el-card>
</template>

<script>
import CustomExport from '../customExport/Index.vue'
import SafeSet from './SafeSet.vue'
import ManageDetail from './ManageDetail.vue'
import NoData from '@/components/NoData.vue'
import keepAlive from '@/mixins/keepAlive.js'
//
export default {
  name: 'TaskPlanList',
  mixins: [keepAlive],
  components: { CustomExport, SafeSet, ManageDetail, NoData },
  data() {
    return {
      searchForm: {
        planName: '',
        projectId: '',
        safeManageId: '',
        patrolMode: '',
        planType: '',
        planStatus: 0,
        patrolUnit: ''
      },

      isShowRecord: false,
      showExport: false,
      setShow: false,
      loading: false,
      safeManageList: [],
      patrolModeList: ['线路', '点位'],
      planTypeList: ['日巡查', '周巡查', '月巡查'],
      planStatusList: ['启用', '禁用'],
      patrolUnitList: ['管理抽查', '项目自查'],
      planList: [],
      planId: '',
      page: 1,
      size: 10,
      total: 0
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    '$store.state.buttonList': {
      deep: true,
      immediate: true,
      handler() {
        if (this.$route.query.projectId) {
          this.searchForm.projectId = this.$route.query.projectId
        }
        this.initSearchForm()
      }
    }
  },

  created() {
  },
  methods: {
    initSearchForm() {
      this.patrolUnitList = [] // ['管理抽查', '项目自查']
      if (this.$store.state.buttonList.some((item) => item.butCode === 'PLA_SEL_04')) {
        this.patrolUnitList.unshift('项目自查')
        this.searchForm.patrolUnit = '2'
      }
      if (this.$store.state.buttonList.some((item) => item.butCode === 'PLA_SEL_03')) {
        this.patrolUnitList.unshift('管理抽查')
        this.searchForm.patrolUnit = '1'
      }
      this.loadSafeManageList()
      this.patrolUnitList.length > 0 && this.loadData()
    },

    loadSafeManageList() {
      this.$axios.get(this.$apis.patrol.selectSafeManageList).then(res => {
        this.safeManageList = res || []
      })
    },

    loadData() {
      this.loading = true
      this.$axios.get(this.searchForm.patrolUnit === '1' ? this.$apis.patrol.selectPlaneByPage : this.$apis.patrol.selectPlanePage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.planList = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },

    onAdd() {
      this.$router.push({ name: 'patrolTaskAdd' })
    },

    onDetail(id) {
      this.$router.push({
        name: 'patrolPointDetail',
        params: {
          id
        }
      })
    },

    onOperate(row) {
      if (row.planStatus === 1 && row.planeStopTime && this.$dayjs().valueOf() > this.$dayjs(row.planeStopTime).valueOf()) {
        this.$confirm('自动禁用日期需大于当前日期或为空才可开启任务, 是否继续?', '提示', {
          confirmButtonText: '去编辑',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isShowRecord = true
        })
        return
      }
      this.$confirm(`确认${row.planStatus === 0 ? '禁用' : '启用'}该任务【${row.planName}】, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrol.updatePlanStatus, {
          planId: row.planId
        }).then(() => {
          this.loadData()
        })
      })
    },

    onEdit(planId) {
      this.isShowRecord = true
      this.planId = planId
    },

    onRecord(planId) {
      this.$router.push({ name: 'patrolTaskPlanDetail', params: { id: planId } })
    },

    onDelete(row) {
      this.$confirm(`确认删除该计划【${row.planName}】, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrol.deletePlane, {
          planId: row.planId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }

}
</script>

<style scoped lang='scss'></style>
